import { Icons } from "../components/common/Icons";

const empSidebarItems = [
  { key: "dashboard", label: "Dashboard", icon: Icons.Dashboard },
  { key: "profile", label: "Profile", icon: Icons.Profile },
  { key: "onboarding", label: "Onboarding", icon: Icons.Onboarding },
  { key: "offboarding", label: "Offboarding", icon: Icons.Logout },
  { key: "attendance", label: "Attendance", icon: Icons.Attendance },
  { key: "leave", label: "Leave", icon: Icons.Leave },
  { key: "payroll", label: "Payroll", icon: Icons.DollarSign },
  { key: "assets", label: "Assets", icon: Icons.Monitor },
  { key: "timeline", label: "Timeline", icon: Icons.Activity },
  { key: "calendar", label: "Calendar", icon: Icons.CalendarDays },
  { key: "announcements", label: "Notifications", icon: Icons.Bell },
  { key: "chat", label: "Chat", icon: Icons.MessageSquare },
  { key: "helpdesk", label: "Help Desk", icon: Icons.HelpCircle },
  { key: "policies", label: "Policies", icon: Icons.BookOpen },
  { key: "notes", label: "Notes", icon: Icons.Edit },
  // { key: "performance", label: "Performance", icon: Icons.Award },
  { key: "settings", label: "Settings", icon: Icons.Settings }
];

// Defaults
const empInfo = { name:"", id:"", email:"", role:"", team:"", manager:"", startDate:"", location:"" };
const empChecklist = [];
const empOnboardDocs = [];
const empAttendanceData = { totalDays:0, present:0, leaves:0, holidays:0 };
const empLeaveSummary = [];
const empDailyAtt = {};
const empMonthlyStats = {};
const empInitLeaveReqs = [];
const empInitPermReqs = [];
const empCalEvents = [];
const empNotifications = [];
const empChatMessages = [];
const empTimeline = [];
const empAssets = [];
const empSoftware = [];
const empAITools = [];
const empTickets = [];
const empPolicies = [];
const empPayslips = [];
const empProfileDetails = [];
const empUploadedDocs = [];

export { empInfo, empChecklist, empOnboardDocs, empAttendanceData, empLeaveSummary, empDailyAtt, empMonthlyStats, empInitLeaveReqs, empInitPermReqs, empCalEvents, empNotifications, empChatMessages, empTimeline, empAssets, empSoftware, empAITools, empTickets, empPolicies, empPayslips, empProfileDetails, empUploadedDocs, empSidebarItems };
